// extracted by mini-css-extract-plugin
export var half = "TxtImg-module--half--12XWS";
export var third = "TxtImg-module--third--3RxqE";
export var imgFirst = "TxtImg-module--imgFirst--2aLD0";
export var txt = "TxtImg-module--txt--_12Vl";
export var img = "TxtImg-module--img--2nIo4";